import dayjs from "dayjs";
import { IBrandListData } from "../modules/mfrm-buybox/mfrm-buybox.view";
import { _deliveryMessage } from "../modules/mfrm-buybox/components/buybox-devliery-by-message";
import { _getProductType } from "../themes/mattressfirm/views/components/delivery-message/deliverymessage.component";

export interface IBatchDeliveryMessage {
    ItemId: string | undefined;
    Brand: string | undefined;
    brandList: any;
    deliveryDays: string | undefined;
    VariantId: number;
    ShippingInfo: string;
    DeliveryMessage: string | undefined;
    coreDefaultMessage: string | undefined
}
const GetBatchDeliveryMessage = (prductIdsAndTypes: IBatchDeliveryMessage[]): IBatchDeliveryMessage[] => {
    return prductIdsAndTypes?.map((product: IBatchDeliveryMessage) => {
        let deliveryByMessage: string | undefined = '';
        let deliveryByMessageRange = '';
        const productType = _getProductType(product.ShippingInfo);
        if (productType.toLowerCase() === "core") {
            deliveryByMessage = product.coreDefaultMessage;
        }
        else if (productType.toLowerCase() === "drop ship" || productType.toLowerCase() === "small parcel" || !deliveryByMessage) {
            let deliveryDays = product.deliveryDays;
            if (
                !deliveryDays &&
                product.brandList &&
                product.brandList?.length > 0) {
                if (product.Brand) {
                    product.brandList?.map((brandList: IBrandListData) => {
                        if (brandList?.brandName?.toLowerCase() === product.Brand) {
                            deliveryDays =
                                brandList.brandLeadtime !== undefined && brandList.brandLeadtime !== '' && brandList.brandLeadtime !== null
                                    ? brandList.brandLeadtime
                                    : '';
                        }
                    });
                }
            }
            if (deliveryByMessage === '' && deliveryDays && deliveryDays !== '' && deliveryDays !== undefined) {
                const daysSpan = deliveryDays?.split('-');
                if (daysSpan && daysSpan[1] !== undefined && daysSpan.length) {
                    daysSpan?.map((item: string, index: number) => {
                        const date = new Date();
                        const deliveryDate = date.setDate(date.getDate());
                        if (parseInt(item, 10) > 0) {
                            let numberOfDays = parseInt(item, 10);
                            let newDate = deliveryDate;
                            while (numberOfDays > 0) {
                                newDate = date.setDate(date.getDate() + 1);
                                if (dayjs(newDate).format('d') !== '0' && dayjs(newDate).format('d') !== '6') {
                                    numberOfDays--;
                                }
                            }
                            deliveryByMessage = dayjs(newDate).format('MMM D');
                            if (deliveryByMessageRange !== '') {
                                deliveryByMessageRange = `${deliveryByMessageRange} to ${deliveryByMessage}`;
                            } else {
                                deliveryByMessageRange = deliveryByMessage;
                                newDate = date.setDate(date.getDate() - parseInt(item[0], 10));
                            }
                        }
                    });
                    deliveryByMessage = deliveryByMessageRange;
                } else {
                    deliveryByMessage = _deliveryMessage(deliveryDays);
                }
            }
        }
        return {
            ...product,
            DeliveryMessage: deliveryByMessage
        };
    });
};
export default GetBatchDeliveryMessage;